import { render } from "./SettingsPage.vue?vue&type=template&id=2ecdf2d1&scoped=true"
import script from "./SettingsPage.vue?vue&type=script&lang=js"
export * from "./SettingsPage.vue?vue&type=script&lang=js"

import "./SettingsPage.vue?vue&type=style&index=0&id=2ecdf2d1&lang=scss&scoped=true"

import exportComponent from "/lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ecdf2d1"]])

export default __exports__